import React from 'react';
import styles from "./sortable-column.css";

let SortableColumn = ({ title, name, onSort, sortBy, sortOrder, sortType, children, classes = '' }) => {
  return (
    <th className={classes}>
      <div className={styles["sort-items"]}>
        <div className={styles["sort-title"]}>
          {children || title}
        </div>
        <div className={styles["sort-arrows"]}>
          <i className={`material-icons ${styles['sort-arrow-up']} ${(sortBy === name && sortOrder === 'asc' ? styles.active : '')}`} 
            onClick={() => onSort(name, 'asc', sortType)}>
              arrow_drop_up
          </i>
          <i className={`material-icons ${styles['sort-arrow-down']} ${(sortBy === name && sortOrder === 'desc' ? styles.active : '')}`} 
            onClick={() => onSort(name, 'desc', sortType)}>
              arrow_drop_down
          </i>
        </div>
      </div>
    </th>
  )
};

export default SortableColumn;
